import {
  AmbientLight,
  DirectionalLight,
  Group,
  HemisphereLight,
  SpotLight,
} from 'three';
import { COLORS } from '../config/colors';

export function createLighting(): Group {
  const lights = new Group();
  const ambient = new AmbientLight(0xffffff, 0.72);
  lights.add(ambient);
  const hemisphere = new HemisphereLight(COLORS.sky, COLORS.grass, 1.15);
  lights.add(hemisphere);
  const sun = new DirectionalLight(0xfff1cf, 3.15);
  sun.position.set(28, 42, 25);
  sun.castShadow = true;
  sun.shadow.mapSize.set(1536, 1536);
  sun.shadow.camera.left = -55;
  sun.shadow.camera.right = 55;
  sun.shadow.camera.top = 48;
  sun.shadow.camera.bottom = -48;
  sun.shadow.bias = -0.0004;
  lights.add(sun);
  const rescueSpot = new SpotLight(COLORS.warning, 4, 52, Math.PI / 5, 0.65, 1.3);
  rescueSpot.position.set(14, 18, 23);
  rescueSpot.target.position.set(2, 0, 0);
  lights.add(rescueSpot, rescueSpot.target);
  return lights;
}
